import { buildSyncUrl, getHeaders, getSyncHeaders } from './utils';
import { getBullmanImageName } from '../utils/broadcastingImage';
import { HttpRequest } from '../stores/types/types';
import { appLogger } from '../utils/datadog';
import { Entity } from '../types/interfaces';
import { BroadcastEncodingOptions } from '../stores/reducers/broadcasting';

export function GetBroadcastServer(token: string, meeting: number) {
	const bullmanImageName = getBullmanImageName();
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/check/${meeting}`, {
		method: 'put',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ bullmanImageName }),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/server/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function StartBroadcast(
	token: string,
	meeting: number,
	resolution: string,
	broadcast: boolean = true,
	record: boolean = false,
) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/start/${meeting}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ resolution, broadcast, record }),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/start/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function StopBroadcast(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/stop/${meeting}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.ok;
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/stop/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function ManuallyCreateBroadcastServer(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/internal/broadcast/${meeting}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.ok;
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/internal/broadcast/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function GetEventsSessionRtmpEndpoint(
	token: string,
	sessionUuid: string,
	language: string,
) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/events/rtmp/${sessionUuid}/${language}`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/events/rtmp/${sessionUuid} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function GetEventsLegacyRtmpEndpoint(token: string, channel: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/events-legacy/endpoint/${channel}`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/events/endpoint/${channel} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function UpdateBroadcastEndpoint(
	token: string,
	meeting: number,
	name: string,
	rtmpAddress: string,
	streamKey: string,
) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/endpoint/${meeting}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ name, rtmpAddress, streamKey }),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`COULD NOT UPDATE ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/endpoint/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function GetRtmpEndpoint(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/endpoint/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/endpoint/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function UpdateUseCustomBroadcastEndpoint(
	token: string,
	meeting: number,
	useCustomEndpoint: boolean,
) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/use-custom-endpoint/${meeting}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ useCustomEndpoint }),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`COULD NOT UPDATE ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/use-custom-endpoint/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function AutoStartBroadcast(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/auto-start/${meeting}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.ok;
		}
		throw new Error(`COULD NOT GET ${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/auto-start/${meeting} server status: ${res.status}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function SetDatabaseStreamState(token: string, meeting: number, streamState: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/stream-state`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
		body: JSON.stringify({
			stream_state: streamState,
			meeting,
		}),
	}).then((res) => {
		if (res.ok) {
			return res.ok;
		}
		throw new Error(`Could not set stream state for meeting ${meeting}`);
	}).catch((error) => {
		console.error(error);
	});
}

export function GetDatabaseStreamState(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/stream-state/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`Could not set stream state for meeting ${meeting}`);
	}).catch((error) => {
		console.error(error);
	});
}

export async function GetBroadcastingErrorLogs(meeting: number) {
	const logURL = await fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/error-logs/${meeting}`, {
		method: 'GET',
		headers: getHeaders() as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error(`Could not get error logs for meeting ${meeting}`);
	}).catch((error) => {
		console.error(error);
	});

	if (logURL && logURL.logUrl) {
		console.log(`BROADCASING ERROR. Full log available at ${logURL.logUrl}`);
	}
}

export function ResetBroadcastServer(token: string, meeting: number) {
	const bullmanImageName = getBullmanImageName();
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/broadcast/reset-broadcast-state/${meeting}`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ bullmanImageName }),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		throw new Error('COULD NOT RESET BROADCAST');
	}).catch((error) => {
		console.error(error);
	});
}

export function isValidateRTMPEndpoint(streamAddress: string, streamKey: string) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/validate/rtmp-destination`, {
		method: 'POST',
		headers: getHeaders() as any,
		body: JSON.stringify({
			streamAddress,
			streamKey,
		}),
	}).then((res) => {
		if (res.ok) {
			return true;
		}

		return false;
	}).catch((error) => {
		console.error(error);

		return false;
	});
}

export const StartSpielbergBroadcast = async (
	token: string,
	meetingId: number,
	broadcasting: boolean = true,
	recording: boolean = true,
	encodingOptionOverrides: BroadcastEncodingOptions = {},
): Promise<boolean> => {
	try {
		const response = await fetch(
			buildSyncUrl(`v1/room/${meetingId}/broadcast/start`),
			{
				method: HttpRequest.Post,
				headers: getSyncHeaders(token),
				body: JSON.stringify({
					broadcasting,
					recording,
					encodingOptionOverrides,
				}),
			},
		);

		if (response.ok) {
			return true;
		}

		appLogger.error(`StartSpielbergBroadcast error: ${response.status}`);
	} catch (error) {
		appLogger.error(`StartSpielbergBroadcast error: ${error}`);
	}

	return false;
};

export const StopSpielbergBroadcast = async (
	token: string,
	meetingId: number,
): Promise<boolean> => {
	try {
		const response = await fetch(
			buildSyncUrl(`v1/room/${meetingId}/broadcast/stop`),
			{
				method: HttpRequest.Put,
				headers: getSyncHeaders(token),
			},
		);

		if (response.ok) {
			return true;
		}

		appLogger.error(`StopSpielbergBroadcast error: ${response.status}`);
	} catch (error) {
		appLogger.error(`StopSpielbergBroadcast error: ${error}`);
	}

	return false;
};

export const GetSpielbergBroadcast = async (
	token: string,
	meetingId: number,
): Promise<Entity | null> => {
	try {
		const response = await fetch(
			buildSyncUrl(`v1/room/${meetingId}/broadcast`),
			{
				method: HttpRequest.Get,
				headers: getSyncHeaders(token),
			},
		);

		if (response.ok) {
			return response.status === 200
				? response.json()
				: null;
		}

		appLogger.error(`StartSpielbergBroadcast error: ${response.status}`);
	} catch (error) {
		appLogger.error(`StartSpielbergBroadcast error: ${error}`);
	}

	return null;
};
